import React, { useState } from "react";
import AsideText from "./mdx/text/Aside";
import H2 from "./mdx/text/H2";

export const Item = ({ children }) => {
	return <>{children}</>;
};

export const Sources = ({ children, initiallyVisibleCount = 2 }) => {
	const [showAll, setShowAll] = useState(false);

	const items = React.Children.toArray(children);

	const handleToggle = () => {
		setShowAll((prev) => !prev);
	};

	return (
		<AsideText lightBackground>
			<div className="sources-container">
				<H2 format>Źródła</H2>
				<ul id="sources-list" aria-live="polite">
					{items.map((item, index) => {
						const isVisible = showAll || index < initiallyVisibleCount;
						return (
							<li
								key={index}
								className={isVisible ? "source-visible" : "source-hidden"}
								aria-hidden={!isVisible}
							>
								{item}
							</li>
						);
					})}
				</ul>

				{items.length > initiallyVisibleCount && (
					<button
						type="button"
						onClick={handleToggle}
						aria-expanded={showAll}
						aria-controls="sources-list"
						className="pd-btn pd-btn--link"
					>
						{showAll ? "Pokaż mniej" : "Pokaż więcej"}
					</button>
				)}
			</div>
		</AsideText>
	);
};
